

const App = {
    run: function(inner, block) {
        // recommend to use inner element as selector for block to run js
        const accordions = inner.querySelectorAll('.accordion-item')

		accordions.forEach((accordion) => {
			const header = accordion.querySelector('.header')

			accordion.content = '.content'
			accordion.contentWrapper = '.content-wrapper'
			

			const currAccordion = accordion
			const currContent = currAccordion.querySelector('.content')
			const currContentWrapper = currContent.querySelector('.content-wrapper')
			const accordionClass = currAccordion.classList
			

			currAccordion.classList.add('accordion-hidden')

			currContent.dataset.contentHeight = currContentWrapper.scrollHeight

			header.addEventListener('click', _.throttle(() => {
				accordions.forEach((accordion) =>  (currAccordion !== accordion && accordion.classList.contains('expand') ) && this.collapse(accordion) )

				if (accordionClass.contains('expand')) {
					this.collapse(accordion)
				} else {
					this.expand(accordion)
				} 
			}, 100) );

			this.initSubAccordion(currAccordion)
		})
    },

	initSubAccordion: function(currAccordion) {
		const subAccordions = currAccordion.querySelectorAll('.sub-accordion-item')

		if ( subAccordions.length > 0 ) {
			subAccordions.forEach(subAccordion => {

				subAccordion.content = '.sub-accordion-content'
				subAccordion.contentWrapper = '.sub-content-wrapper'

				const subHeader = subAccordion.querySelector('.sub-header')
				const currSubAccordion = subAccordion
				const currSubContent = currAccordion.querySelector('.sub-accordion-content')
				const currSubContentWrapper = currSubAccordion.querySelector('.sub-content-wrapper')
				const subAccordionClass = currSubAccordion.classList

				currSubAccordion.classList.add('accordion-hidden')

				currSubContent.dataset.contentHeight = currSubContentWrapper.scrollHeight

				subHeader.addEventListener('click', _.throttle(() => {
					subAccordions.forEach((accordion) =>  (currSubAccordion !== accordion && accordion.classList.contains('expand') ) && this.collapse(accordion) )
	
					if (subAccordionClass.contains('expand')) {
						this.collapse(subAccordion)
					} else {
						this.expand(subAccordion)
					} 
				}, 100) );
			});
		}
	},

	collapse: function(accordion) {
		const content = accordion.querySelector(accordion.content)
		const contentWrapper = content.querySelector(accordion.contentWrapper)

		content.style.maxHeight = `${contentWrapper.scrollHeight}px`
		content.offsetHeight
		accordion.classList.remove('expand')
		
		accordion.classList.add('collapsing')
		content.style.maxHeight = ''
		setTimeout(() => {
			accordion.classList.add('accordion-hidden')
			accordion.classList.remove('collapsing')
		}, 320)
	},

	expand: function(accordion) {
		const content = accordion.querySelector(accordion.content)
		const contentWrapper = content.querySelector(accordion.contentWrapper)

		accordion.classList.remove('accordion-hidden')
		content.style.maxHeight = 0
		content.offsetHeight
		accordion.classList.add('expanding')
		content.style.maxHeight =  contentWrapper.scrollHeight < parseInt(content.dataset.contentHeight) ? `${parseInt(content.dataset.contentHeight)}px` : `${contentWrapper.scrollHeight}px`
		setTimeout(() => {
			accordion.classList.add('expand')
			content.style.maxHeight = ''
			accordion.classList.remove('expanding')
		}, 320)
	},

    initializeBlock: function(block) {
        let wrapper = block.querySelector('.accordion-wrapper')
        this.run(wrapper, block)
    },
    initializeBlockEditor: function(block) {
        // gutenberg fire the block
        App.initializeBlock(block[0])
    },
}

window.addEventListener('DOMContentLoaded', () => {
	const blocks = document.querySelectorAll('.elmntl-accordion')

	blocks.forEach(block => {
		App.initializeBlock(block)
	})
})

if (window.acf) {
    window.acf.addAction(
        'render_block_preview/type=accordion',
        App.initializeBlockEditor
    )
}